import {ButtonClass} from "@sharedComponents/Button/types";

export const isLink = (buttonClass: string): boolean => {
    return parseInt(buttonClass, 10) === ButtonClass.Link;
}
